<template>
  <div class="home" ref="homeContent">
    <section class="d-flex flex-grow-1">
      <b-container fluid class="d-flex flex-column m-0 p-0">
        <b-row class="flex-grow-1 no-gutters">
          <b-col id="profileBackground" md="6" offset-md="3" :style='"background-color:" + profile.background_color + ";" + profile.background_image_style.css'>
              <div class="py-4 px-3 px-md-4 d-flex flex-column align-items-center">
                <div id="profilePhoto" class="my-4"></div>
                <div class="professional-name mb-1" :style='"color:" + profile.primary_color'>{{profile.name}}</div>
                <div class="mb-1" :style='"color:" + profile.secondary_color'>{{getFormattedProfessionalRegistration()}}</div>
                <div class="mb-5" :style='"color:" + profile.secondary_color'>{{getFormattedSpecialties()}}</div>

                <a v-for="(field, index) in profile.items" :key="field.id + '_' + index" :href="getProfileFieldUrl(field)" target="_blank" class="custom-field mb-3 d-flex justify-content-between align-items-center" :class="field.name !== '' ? 'text-left' : ''">
                  <div>
                    <div v-if="field.name !== ''" class="mb-1" :style='"color:" + profile.secondary_color'>{{field.name}}</div>
                    <div class="custom-field-content" :style='"color:" + profile.primary_color'>{{field.content}}</div>
                  </div>
                  <div class="icon" v-if="field.show_icon && getProfileFieldIcon(field.type) !== ''" :style='"color:" + profile.primary_color'>
                    <i :class="getProfileFieldIcon(field.type) + ' mr-2'"></i>
                  </div>
                </a>

              </div>
              <div class="professional-card-footer p-3 mt-4" :style='"color:" + profile.primary_color + ";border-color:" + profile.secondary_color'>
                <a href="https://consultaja.com" target="_blank">powered by Consultaja.com</a>
              </div>
          </b-col>
        </b-row>
      </b-container>

    </section>
  </div>
</template>

<script>
export default {
  name: 'home',
  data() {
    return {
      isLoading: null,

      fieldTypes: [
        { value: 'agenda', name: 'Agenda Online', icon: 'far fa-calendar-alt' },
        { value: 'email', name: 'E-mail', icon: 'far fa-envelope' },
        { value: 'address', name: 'Endereço', icon: 'far fa-map-marker-alt' },
        { value: 'instagram', name: 'Instagram', icon: 'fab fa-instagram' },
        { value: 'link', name: 'Link', icon: 'far fa-link' },
        { value: 'phone', name: 'Telefone', icon: 'far fa-phone fa-flip-horizontal' },
        { value: 'text', name: 'Texto livre', icon: '' },
        { value: 'whatsapp', name: 'Whatsapp', icon: 'fab fa-whatsapp' }
      ],
      backgroundImageStyles: [
        { value: 'cover', name: 'Cobrir', css: 'background-size:cover;' },
        { value: 'contain', name: 'Conter', css: 'background-size:contain;' },
        { value: 'repeat', name: 'Repetir', css: 'background-repeat:repeat;' },
      ],

      avatar: require('@/assets/images/digital-card-avatar.jpg'),
      profile: {
        id: null,
        slug: null,
        photo: null,
        name: null,
        primary_color: '#333333',
        secondary_color: '#999999',
        background_color: '#eeeeee',
        background_image: null,
        background_image_style: { value: 'cover', name: 'Cobrir', css: 'background-size:cover;' },
        enabled: false,
        items: [],
        specialities: [],
        professional_registration: {
          id: null,
          council: null,
          state: null,
          number: null
        },
      }
    }
  },
  mounted() {
    this.eventBus.$on('IS_LOADING', (isLoading) => {
      if(isLoading) {
        this.isLoading = this.$loading.show({
          container: this.$refs.homeContent,
          canCancel: false,
          isFullPage: false,
          color: '#21A7F0',
          backgroundColor: '#212C3B'
        });
      } else {
        if(typeof this.isLoading != 'undefined' && this.isLoading != null)
          this.isLoading.hide();
      }
    });
    this.getDigitalCard();
    // this.getAgenda();
  },
  methods: {
    getDigitalCard() {
      this.eventBus.$emit('IS_LOADING', true);
      this.api.getDigitalCard(this.$route.params.slug).then(res => {
        this.eventBus.$emit('IS_LOADING', false);
        let profileData = res.data;

        profileData.background_image_style = this.backgroundImageStyles.find(style => style.value === profileData.background_image_style);
        if(profileData.background_image_style === undefined) {
          profileData.background_image_style = { value: 'cover', name: 'Cobrir', css: 'background-size:cover;' };
        }
        this.profile = profileData;
        console.log(this.profile);
        this.updatePhoto();
        this.updateBackgroundImage();

        if(process.env.VUE_APP_SHOW_CONSOLE)
          console.log('Success Get Digital Card', res);
      }).catch(err => {
        this.eventBus.$emit('IS_LOADING', false);
        // window.location.href = 'https://www.consultaja.com/';

        if(process.env.VUE_APP_SHOW_CONSOLE)
          console.log('Error Get Digital Card', err.response);
      });
    },

    getFormattedProfessionalRegistration() {
      if(this.profile.professional_registration == null || this.profile.professional_registration.number == null) {
        return '';
      }
      let registration = [];
      if(this.profile.professional_registration.council != null) {
        registration.push(this.profile.professional_registration.council);
      }
      if(this.profile.professional_registration.state != null) {
        registration.push(this.profile.professional_registration.state);
      }
      registration.push(this.profile.professional_registration.number);
      return registration.join(' ');
    },

    getFormattedSpecialties() {
      let specialties = [];
      this.profile.specialities.forEach(specialty => {
        specialties.push(specialty.name);
      });
      return specialties.join(' | ');
    },

    getProfileFieldIcon(fieldType) {
      return this.fieldTypes.find(type => type.value === fieldType).icon;
    },

    getProfileFieldUrl(field) {
      if(field.type == 'email') {
        return 'mailto:' + field.content;
      }
      else if(field.type == 'address') {
        return 'https://www.google.com/maps/place/' + field.content.replace(' ', '+');
      }
      else if(field.type == 'instagram') {
        if(field.content.indexOf('http://') === 0 || field.content.indexOf('http://') === 0){
          return field.content;
        }
        return 'https://instagram.com/' + field.content.replace('@', '');
      }
      else if(field.type == 'agenda' || field.type == 'link') {
        return field.url;
      }
      else if(field.type == 'phone') {
        return 'tel:+55' + field.content.replace(/\D/g,'');
      }
      else if(field.type == 'whatsapp') {
        return 'https://wa.me/55' + field.content.replace(/\D/g,'');
      }
      return null;
    },

    updatePhoto() {
      let photo = '';
      if(this.profile.photo != null) {
        photo = this.profile.photo;
      } else {
        photo = require('@/assets/images/digital-card-avatar.jpg');
      }
      document.getElementById('profilePhoto').style.backgroundImage = 'url("' + photo + '")';
      console.log(photo);
    },

    updateBackgroundImage() {
      let photo = '';
      if(this.profile.background_image != null) {
        photo = this.profile.background_image;
        document.getElementById('profileBackground').style.backgroundImage = 'url("' + photo + '")';
        console.log(photo);
      }
    },
  }
}
</script>

<style lang="scss">
  .home {
    flex: 1;
    flex-flow: column;
    display: flex;

    #profileBackground {
      background-position: center;
      background-repeat: no-repeat;
      text-align: center;
      font-size: 14px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      #profilePhoto {
        width: 120px;
        height: 120px;
        background: #f0f0f0 no-repeat 50%;
        background-size: cover;
      }

      .professional-name {
        font-size: 16px;
      }

      .custom-field {
        background: #fffffff2;
        border-radius: 14px;
        padding: 14px;
        width: 100%;

        &:hover {
          text-decoration: none;
        }

        .custom-field-content {
          font-size: 15px;
        }

        .icon {
          font-size: 16px;
        }
      }

      .professional-card-footer {
        border-top: 1px solid #ccc;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        align-self: end;
        font-size: 15px;

        a,
        a:hover, {
          color: inherit;
          text-decoration: none;
        }
      }
    }
  }
</style>
